import React from 'react';
import { urlFlag } from '../../common/urlBase';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const CardDetailCourse = ({ course }) => {

    const {
        language,
        identifier,
        color,
        level,
        limitMembers,
        teacher
    } = course;

    return (
        <div className='w-full bg-slate-100 rounded-md p-4 shadow-sm'>
            <div className="w-full flex justify-between mb-4">
                <div>
                    <p className='text-sm text-gray-900 font-bold tracking-wide uppercase'>
                        {language ? language?.name : '-'}
                    </p>
                    <div className="flex items-center">
                        <span className={classNames(
                            color ? color?.clase : "bg-slate-100",
                            'inline-block w-[14px] h-[14px] rounded-lg mr-2'
                        )}></span>
                        <p className='text-[.8rem] text-indigo-700 font-bold tracking-wide uppercase'>
                            {level ? `${level?.name}` : '-'}
                        </p>
                    </div>
                </div>
                <div>
                    {language
                        ? (
                            <img className="w-[32px]" src={`${urlFlag}${language?.path}`} alt="flag" />
                        )
                        : null}
                </div>
            </div>
            <div className="w-full grid grid-cols-1 gap-4 mt-6">
                <div className='w-full flex flex-col justify-center items-center'>
                    <p className="font-normal text-[.7rem] text-gray-600 leading-6">Identidicador de curso</p>
                    <p className="text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center">{
                        identifier !== undefined ? `[ ${identifier} ]` : '-'
                    }</p>
                </div>
                <div className='w-full flex flex-col justify-center items-center'>
                    <p className="font-normal text-[.7rem] text-gray-600 leading-6">Profesor del curso</p>
                    <p className="text-slate-800 font-semibold text-[.8rem] tracking-wide capitalize">{
                        teacher !== undefined ? `${teacher?.firstName} ${teacher?.secondName ? teacher?.secondName : ''} ${teacher?.lastName} ${teacher?.secondSurname ? teacher?.secondSurname : ''}` : '-'
                    }</p>
                </div>
                <div className='w-full flex flex-col justify-center items-center'>
                    <p className="font-normal text-[.7rem] text-gray-600 leading-6">Lugares disponibles</p>
                    <p className="text-slate-800 font-semibold text-[.8rem] tracking-wide capitalize">{
                        limitMembers !== undefined ? limitMembers : '-'
                    }</p>
                </div>
            </div>
        </div>
    )
}
